export default {
  'menu.welcome': 'Welcome',
  'menu.more-blocks': 'More Blocks',
  'menu.home': 'Home',
  'menu.admin': 'Admin',
  'menu.admin.sub-page': 'Sub-Page',
  'menu.admin.sys_users': 'User Management',
  'menu.admin.sys_roles': 'Role Management',
  'menu.admin.sys_permissions': 'Permission Management',
  'menu.admin.sys_settings': 'System Settings',
  'menu.sys_users': 'User Management',
  'menu.sys_roles': 'Role Management',
  'menu.sys_permissions': 'Permission Management',
  'menu.sys_settings': 'System Settings',
  'menu.prj_projects': 'Project Management',
  'menu.prj_contracts': 'Contract Management',
  'menu.项目模块': 'Project Module',
  'menu.项目模块.项目管理': 'Project Management',
  'menu.项目模块.合同管理': 'Contract Management',
  'menu.项目模块.工人管理': 'Worker Management',
  'menu.项目模块.派工登记': 'Work Dispatch Registration',
  'menu.项目模块.收款登记': 'Payment Management',
  'menu.项目模块.完工登记': 'Completion Registration',
  'menu.项目模块.结项登记': 'Closing Registration',
  'menu.项目模块.收货登记': 'Receipt Registration',
  'menu.库存模块': 'Inventory Module',
  'menu.库存模块.SKU分类': 'SKU Categories',
  'menu.库存模块.SKU': 'SKU',
  'menu.库存模块.仓库管理': 'Warehouse Management',
  'menu.采购模块': 'Purchase Module',
  'menu.采购模块.供应商列表': 'Suppliers',
  'menu.采购模块.采购订单': 'Purchase Orders',
  'menu.系统管理': 'System Management',
  'menu.系统管理.用户管理': 'User Management',
  'menu.系统管理.角色管理': 'Role Management',
  'menu.系统管理.权限管理': 'Permission Management',
  'menu.系统管理.系统设置': 'System Settings',
  'menu.示例': 'Examples',
  'menu.示例.dashboard': 'Dashboard',
  'menu.示例.dashboard.analysis': 'Analysis',
  'menu.示例.dashboard.monitor': 'Monitor',
  'menu.示例.dashboard.workplace': 'Workplace',
  'menu.示例.form': 'Form',
  'menu.示例.form.basic-form': 'Basic Form',
  'menu.示例.form.step-form': 'Step Form',
  'menu.示例.form.step-form.info': 'Step Form (Transfer Info)',
  'menu.示例.form.step-form.confirm': 'Step Form (Confirm)',
  'menu.示例.form.step-form.result': 'Step Form (Result)',
  'menu.示例.form.advanced-form': 'Advanced Form',
  'menu.示例.list': 'List',
  'menu.示例.list.table-list': 'Table List',
  'menu.示例.list.basic-list': 'Basic List',
  'menu.示例.list.card-list': 'Card List',
  'menu.示例.list.search-list': 'Search List',
  'menu.示例.list.search-list.articles': 'Search List (Articles)',
  'menu.示例.list.search-list.projects': 'Search List (Projects)',
  'menu.示例.list.search-list.applications': 'Search List (Applications)',
  'menu.示例.profile': 'Profile',
  'menu.示例.profile.basic': 'Basic Profile',
  'menu.示例.profile.advanced': 'Advanced Profile',
  'menu.示例.result': 'Result',
  'menu.示例.result.success': 'Success',
  'menu.示例.result.fail': 'Fail',
  'menu.示例.exception': 'Exception',
  'menu.示例.exception.403': '403',
  'menu.示例.exception.404': '404',
  'menu.示例.exception.500': '500',
  'menu.示例.account': 'Account',
  'menu.示例.account.center': 'Account Center',
  'menu.示例.account.settings': 'Account Settings',
  'menu.login': 'Login',
  'menu.register': 'Register',
  'menu.register-result': 'Register Result',
  'menu.dashboard': 'Dashboard',
  'menu.dashboard.analysis': 'Analysis',
  'menu.dashboard.monitor': 'Monitor',
  'menu.dashboard.workplace': 'Workplace',
  'menu.exception.403': '403',
  'menu.exception.404': '404',
  'menu.exception.500': '500',
  'menu.form': 'Form',
  'menu.form.basic-form': 'Basic Form',
  'menu.form.step-form': 'Step Form',
  'menu.form.step-form.info': 'Step Form(write transfer information)',
  'menu.form.step-form.confirm': 'Step Form(confirm transfer information)',
  'menu.form.step-form.result': 'Step Form(finished)',
  'menu.form.advanced-form': 'Advanced Form',
  'menu.list': 'List',
  'menu.list.table-list': 'Search Table',
  'menu.list.basic-list': 'Basic List',
  'menu.list.card-list': 'Card List',
  'menu.list.search-list': 'Search List',
  'menu.list.search-list.articles': 'Search List(articles)',
  'menu.list.search-list.projects': 'Search List(projects)',
  'menu.list.search-list.applications': 'Search List(applications)',
  'menu.profile': 'Profile',
  'menu.profile.basic': 'Basic Profile',
  'menu.profile.advanced': 'Advanced Profile',
  'menu.result': 'Result',
  'menu.result.success': 'Success',
  'menu.result.fail': 'Fail',
  'menu.exception': 'Exception',
  'menu.exception.not-permission': '403',
  'menu.exception.not-find': '404',
  'menu.exception.server-error': '500',
  'menu.exception.trigger': 'Trigger',
  'menu.account': 'Account',
  'menu.account.center': 'Account Center',
  'menu.account.settings': 'Account Settings',
  'menu.account.trigger': 'Trigger Error',
  'menu.account.logout': 'Logout',
  'menu.用户中心': 'User Center',
  'menu.用户中心.用户设置': 'User Settings',
  'menu.editor': 'Graphic Editor',
  'menu.editor.flow': 'Flow Editor',
  'menu.editor.mind': 'Mind Editor',
  'menu.editor.koni': 'Koni Editor',
};
